// extracted by mini-css-extract-plugin
module.exports = {"idea":"styles_idea__2jyvN","layout":"styles_layout__q7OuY","left":"styles_left__4q39S","right":"styles_right__JgOkH"};